export class Tag {
    id: number;
    name: string;

    constructor(data) {
        this.id = (data.id ) ? parseInt(data.id) : null
        this.name = (data.name ) ? data.name : null
    }
}